/* eslint-disable react/jsx-one-expression-per-line */
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Trans, t } from '@lingui/macro';
import { Space } from 'antd';
import BankFeedActions from 'bukku/redux/BankFeed/actions';
import dayjs from 'dayjs';
import React from 'react';
import Hotkeys from "react-hot-keys";
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import FormatNumber from '../../../FormatNumber';
import { BankFeedTransactionLineDiv } from './BankFeedTransactionLineDiv';
import { StyledModal } from './style';

const {
    deleteBankFeedTransaction,
} = BankFeedActions;

export default function DeleteBankFeedTransactionModal({
    record, open, onCancel, deleteState, currency_symbol,
}) {
    const dispatch = useDispatch();
    const isDeleting = deleteState === 'request';

    const { bankFeedId, accountId } = useParams();

    const onDelete = () => {
        dispatch(deleteBankFeedTransaction(bankFeedId, accountId, record.id));
    };

    const content = (
        <Space direction="vertical">
            <Trans>
                Are you sure you want to delete the following?
                <BankFeedTransactionLineDiv>
                    <div className="title">
                        {record.description}
                    </div>
                    <div className="subtitle small-text">
                        <span>
                            <FormatNumber
                                amount={Math.abs(record.debit_amount || record.credit_amount)}
                                currency={currency_symbol}
                            />&nbsp;
                            {record.debit_amount ? 'spent' : 'received'}
                        </span>&nbsp;&bull;&nbsp;
                        <span>
                            {dayjs(record.date).format('DD/MM/YYYY')}
                        </span>
                    </div>
                </BankFeedTransactionLineDiv>
            </Trans>
            <Trans>
                Deleting bank feed transaction&nbsp;
                will not affect your reconciliations and actual bank account balance.
            </Trans>
        </Space>
    );

    return (
        <StyledModal
            title={(
                <>
                    <ExclamationCircleFilled className="title-icon warning" />
                    <Trans>Delete bank feed transaction</Trans>
                </>
            )}
            open={open}
            destroyOnClose
            okText={t`Delete`}
            onOk={onDelete}
            okButtonProps={{ loading: isDeleting }}
            onCancel={onCancel}
            cancelButtonProps={{ disabled: isDeleting }}
        >
            <Hotkeys
                keyName="enter"
                onKeyDown={keyName => {
                    switch (keyName) {
                        case "enter": {
                            onDelete();
                            return true;
                        }
                        default:
                            return false;
                    }
                }}
                filter={() => true}
            >
                { content }
            </Hotkeys>
        </StyledModal>

    );
}
